import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { getDomesticSearchDetail } from './thunk'

const slice = createSlice({
  name: 'domesticSearchPreview',
  initialState: {
    companyInfoData: {},
    isLoading: true,
    isRedirect404: false,
  },
  reducers: {
    resetStore: (state) => {
      state.companyInfoData = {}
      state.isLoading = true
      state.isRedirect404 = false
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDomesticSearchDetail.pending, (state) => {
      state.isLoading = true
      state.isRedirect404 = false
    })
    builder.addCase(getDomesticSearchDetail.fulfilled, (state, action) => {
      state.companyInfoData = action.payload
      state.isLoading = false
    })
    builder.addCase(getDomesticSearchDetail.rejected, (state, action) => {
      state.isLoading = false
      state.isRedirect404 = action.payload
    })
  },
})

export const selectCompanyInfoData = (state) =>
  state[slice.name].companyInfoData
export const selectLoading = (state) => state[slice.name].isLoading
export const selectIsRedirect404 = (state) => state[slice.name].isRedirect404

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
